<script lang="ts" setup>

defineProps<{ opened: boolean }>()

const { t } = useI18n()

const emit =
  defineEmits<{
    (e: "onOpen"): void
    (e: "onClose"): void
    (e: "onToggle"): void
    (e: "onDelete"): void
    (e: "onApply"): void
  }>()

const { event, sendEvent } = useGAEvent(
  `track_select_content_available_`,
  "custom_event"
)

const onClickedFilter = (item: string, category: string) => {
  if (item) {
    event.value = {
      event: "select_content",
      action: "filter",
      category: category.toLowerCase(),
      label: t(`filters.utils.availability.${item}`)
    }

    sendEvent({ clearEcommerce: false })
  }
}

const facetNames = ["inStock", "deductibleProduct"]
</script>

<template>
  <FiltersUtilsDropdown
    content-class="w-[24.5rem] p-4"
    :text="$t('filters.utils.common.availability')"
    :opened="opened"
    @onOpen="emit('onOpen')"
    @onClose="emit('onClose')"
    @onToggle="emit('onToggle')"
    @onDelete="emit('onDelete')"
    @onApply="emit('onApply')"
    :facetName="facetNames"
    id-facet="availability"
  >
    <div
      v-for="(item, index) in facetNames"
      :key="`refinmenet-toggle-${index}`"
      class="space-y-1"
    >
      <AisToggleRefinement
        :attribute="facetNames[index]"
        :label="$t(`filters.utils.availability.${item}`)"
      >
        <template v-slot="{ canRefine, refine, value }">
          <FiltersUtilsOption
            :name="item"
            :checked="value.isRefined"
            :disabled="!canRefine"
            @clicked="
              ($event) => {
                onClickedFilter(item, $t('filters.utils.common.availability'))
                refine(value)
              }
            "
            :text="$t(`filters.utils.availability.${item}`)"
            :n-results="canRefine ? value.count : 0"
            type="toggle"
          />
        </template>
      </AisToggleRefinement>
    </div>
  </FiltersUtilsDropdown>
</template>
